import { Helmet } from 'react-helmet-async';

function StructuredData() {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Дух Приморья",
    "description": "Премиум наборы для настоек из дикоросов Приморья",
    "url": "https://duh-prim.ru",
    "logo": "https://duh-prim.ru/image.png",
    "address": {
      "@type": "PostalAddress",
      "addressRegion": "Приморский край",
      "addressLocality": "Находка",
      "addressCountry": "RU"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Russian"
    }
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Наборы для настоек Дух Приморья",
    "description": "Готовые наборы трав и ягод для приготовления домашних настоек",
    "brand": {
      "@type": "Brand",
      "name": "Дух Приморья"
    },
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "RUB",
      "lowPrice": "90",
      "highPrice": "200",
      "availability": "https://schema.org/InStock"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
  );
}

export default StructuredData;
